__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "coremind-www";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@coremind/admin-core", "1.7.1763429446", () => (() => (__webpack_require__(63777))), 1);
			register("@coremind/apps-core", "0.10.9", () => (() => (__webpack_require__(55443))), 1);
			register("@coremind/billing-core", "1.9.9", () => (() => (__webpack_require__(54014))), 1);
			register("@coremind/camera-core", "0.10.9", () => (() => (__webpack_require__(76781))), 1);
			register("@coremind/docs-core", "1.5.1763429494", () => (() => (__webpack_require__(8769))), 1);
			register("@coremind/identity-core", "1.16.1767332215", () => (() => (__webpack_require__(58451))), 1);
			register("@coremind/inventory-core", "1.21.1763429543", () => (() => (__webpack_require__(51347))), 1);
			register("@coremind/marketplace-core", "1.8.1763429542", () => (() => (__webpack_require__(31814))), 1);
			register("@coremind/notifications-core", "1.3.3", () => (() => (__webpack_require__(8370))), 1);
			register("@coremind/storage-core", "1.3.1767332797", () => (() => (__webpack_require__(85502))), 1);
			register("@coremind/ui-platform-core", "1.5.5", () => (() => (__webpack_require__(15581))), 1);
			register("@coremind/users-core", "0.4.3", () => (() => (__webpack_require__(29778))), 1);
			register("@coremind/workspaces-core", "1.0.1782407449", () => (() => (__webpack_require__(46402))), 1);
			register("react-dom", "^19.1.1", () => (() => (__webpack_require__(97901))), 1);
			register("react-router-dom", "^7.9.5", () => (() => (__webpack_require__(19739))), 1);
			register("react", "^19.1.1", () => (() => (__webpack_require__(23303))), 1);
			initExternal(35108);
			initExternal(67774);
			initExternal(94119);
			initExternal(54894);
			initExternal(38283);
			initExternal(34958);
			initExternal(86150);
			initExternal(87994);
			initExternal(99823);
			initExternal(67172);
			initExternal(58453);
			initExternal(38311);
			initExternal(18414);
			initExternal(97491);
			initExternal(78949);
			initExternal(22007);
			initExternal(92374);
			initExternal(78435);
			initExternal(58534);
			initExternal(18018);
			initExternal(73584);
			initExternal(67813);
			initExternal(64970);
			initExternal(74706);
			initExternal(75564);
			initExternal(38912);
			initExternal(76904);
			initExternal(40582);
			initExternal(49788);
			initExternal(77933);
			initExternal(26736);
			initExternal(7189);
			initExternal(16303);
			initExternal(34216);
			initExternal(90777);
			initExternal(47821);
			initExternal(14981);
			initExternal(38971);
			initExternal(73800);
			initExternal(78472);
			initExternal(6595);
			initExternal(57238);
			initExternal(12764);
			initExternal(77069);
			initExternal(58643);
			initExternal(78352);
			initExternal(51061);
			initExternal(21951);
			initExternal(71300);
			initExternal(32168);
			initExternal(80279);
			initExternal(46944);
			initExternal(29878);
			initExternal(59098);
			initExternal(82785);
			initExternal(50243);
			initExternal(13066);
			initExternal(53089);
			initExternal(46566);
			initExternal(38944);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};